import { FC } from 'react';
import { ImagePreviewGroup, PreviewImage } from 'tedooo-web-design-system/ui';
import classNames from 'classnames';
import './orderImages.scss';

interface IOrderImages {
  images: string[];
}

const MAX_IMAGES = 2;

const OrderImages: FC<IOrderImages> = ({ images }) => {
  const diff = images.length - MAX_IMAGES + 1;

  const imagesTotalCount = images.length;

  return (
    <div className={classNames('order-images', { 'one-image': images.length === 1 })}>
      <ImagePreviewGroup>
        <PreviewImage
          shouldDisplayHoverText={false}
          src={images[0]}
          className="image-first"
          previewClassName="chat-order-image-preview"
        />
        {images.slice(1, imagesTotalCount).map((image) => {
          return (
            <PreviewImage
              shouldDisplayHoverText={false}
              src={image}
              className="second-image-container"
              previewClassName="chat-order-image-preview"
            />
          );
        })}
        {diff > 0 && <div className="overlay">+{diff + 1}</div>}
      </ImagePreviewGroup>
    </div>
  );
};

export default OrderImages;
